<template>
    <div :class="['global-id-cell', { 'global-id-cell__warning-label': showWarning }]">
        <router-link :to="{ path: href, query }">
            {{ title }}
        </router-link>
        <pui-icon
            v-if="showWarning"
            :id="`tooltip-target-warning-${params.data.id}`"
            icon-color="#fd7e14"
            icon-name="warning-circle"
        />
        <b-tooltip
            v-if="showWarning"
            :target="`tooltip-target-warning-${params.data.id}`"
            custom-class="hover-table"
            triggers="hover"
        >
            Some of the fields in this budget request have different values in MSP/PT Risk.
        </b-tooltip>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ICellRendererParams } from 'ag-grid-community';
import { MtpStatus } from '~/utils/interfaces';

interface GlobalIdCell extends ICellRendererParams {
    href: string;
    query: Record<string, string>;
}

@Component({})
export default class GlobalIdCellComponent extends Vue {
    private params?: GlobalIdCell;

    private get title(): string {
        return this.params.value;
    }

    private get href(): string | undefined {
        return this.params.href;
    }

    private get query(): Record<string, string> {
        return this.params.query;
    }

    private get showWarning(): boolean {
        return this.params.data.currentMtpPlanning.hasDifferences && this.params.data.currentMtpPlanning.mtpStatus !== MtpStatus.REVIEWED;
    }
}
</script>

<style scoped lang="scss">
.global-id-cell {
  display: flex;
  align-items: center;
  gap: 6px;

  a:hover {
    text-decoration: none;
  }

  &__warning-label {
    a {
      color: #fd7e14;
    }
  }
}
</style>
